import {createContext, useContext, useEffect, useReducer, useState} from "react";
import {useAsyncEffect} from "ahooks";
import {useCategorySelect} from "../../../api/base";
import {useQryShopProdItemPage} from "../../../api/shopProdItem";
import {mediaMatch} from "../../../utils";
import {useQueryParam} from "../../../hooks";
import {initialState, reducer, setGoodsList, setGoodsListLoading, setCategoryActive, setTotal, setQuery, setMinPrice, setMaxPrice} from "./reducer";
import {useNavigateTo} from "../../../hooks/useNavigateTo";
import {useTranslation} from "react-i18next";

const Context = createContext(initialState);

function GoodsListController() {
  const { state, dispatch } = useGoodsListContext();
  const { loading, getList } = useQryShopProdItemPage();
  const navigateTo = useNavigateTo();
  const { minPrice, maxPrice } = state;
  
  const isMdmax = mediaMatch.isMdmax;
  
  /**
   * 跳转到 商品详情
   * @param id
   */
  const gotoProductDetail = (id) => {
    if (isMdmax) {
      navigateTo(`/goodsDetail?goodsId=${id}`);
    } else {
      let dir = window.location.pathname.endsWith('/') ? '' : '/';
      window.open(`${window.location.origin}${window.location.pathname}${dir}#/goodsDetail?goodsId=${id}`);
    }
  };
  
  /**
   * 获取商品列表
   * @param query
   * @returns {Promise<void>}
   */
  const getGoodsList = async (query, type) => {
    let q = {
      ...state.query,
      ...query
    };
    
    if (!q.categoryIds) {
      delete q.categoryIds;
    }
    
    /**
     * categoryIds,secondCategoryIds,thirdCategoryIds 只能传一个
     * 需要单独处理
     */
    if (type && type === 'changeCategory') {
      delete q.secondCategoryIds;
      delete q.thirdCategoryIds;
    }
    
    if (type && type === 'changeSecond') {
      delete q.thirdCategoryIds;
      delete q.categoryIds;
    }
    
    if (type && type === 'changeThird') {
      delete q.secondCategoryIds;
      delete q.categoryIds;
    }
    
    let { data } = await getList(q);
    
    if (data) {
      dispatch(setQuery(q));
      dispatch(setGoodsList(data.records));
      dispatch(setTotal(Number(data.total)));
    }
    
  };
  
  /**
   * 点击分类
   * @param active
   */
  const setCategorysActive = (active, type) => {
    dispatch(setCategoryActive(active));
    let q = active ? { page: 1 } : {};
    
    if (type === 'second') {
      q.secondCategoryIds = active;
      getGoodsList(q, 'changeSecond');
    } else if (type === 'third') {
      q.thirdCategoryIds = active;
      getGoodsList(q, 'changeThird');
    } else {
      q.categoryIds = active;
      getGoodsList(q, 'changeCategory');
    }
  };
  
  useEffect(() => {
    dispatch(setGoodsListLoading(loading));
    return () => {
    };
  }, [loading]);
  
  
  const getPriceArea = (e) => {
    if (e.keyCode === 13 || e === 'filter_btn') {
      let v = maxPrice;
      if (maxPrice && Number(minPrice) > Number(maxPrice)) {
        v = Number(minPrice) + 1;
        dispatch(setMaxPrice(v));
      }
      
      let query = {
        minPrice,
        maxPrice: v
      };
      
      getGoodsList(query);
    }
    
    if (!maxPrice && !minPrice){
      let query = {
        minPrice,
        maxPrice,
      }
      getGoodsList(query);
    }
    
  };
  
  const setMinPriceHandle = (v) => {
    dispatch(setMinPrice(v));
  };
  
  const setMaxPriceHandle = (v) => {
    dispatch(setMaxPrice(v));
  };
  
  return {
    loading,
    getGoodsList,
    getPriceArea,
    setMinPriceHandle,
    setMaxPriceHandle,
    setCategorysActive,
    gotoProductDetail
  };
}

function useGoodsListContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

export {useGoodsListContext, GoodsListController};

function GetCategorys({ children }) {
  const { dispatch } = useGoodsListContext();
  const { getGoodsList, setCategorysActive } = GoodsListController();
  const [categoryId] = useQueryParam('categoryId');
  const [keyword] = useQueryParam('keyword');
  const { t } = useTranslation();
  
  const { getCategory } = useCategorySelect({
    businessType: 'orderProductType',
    sourceType: 'agent'
  }, {
    manual: true
  });
  
  useAsyncEffect(async () => {
    let { data } = await getCategory();
    
    if (data) {
      let category = data;
      dispatch({
        type: 'setCategorys',
        payload: [
          {
            categoryName: t('全部'),
            categoryEnName: 'ALL',
            categoryId: false,
          },
          ...category
        ]
      });
    }
    
    if (categoryId) {
      setCategorysActive(categoryId);
      getGoodsList({ categoryIds: categoryId });
    } else {
      let itemName = keyword ? { itemName: keyword } : {};
      getGoodsList(itemName);
    }
  }, []);
  
  return (children);
}

export default function GoodsListContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      reducer={reducer}>
      <GetCategorys>
        {children}
      </GetCategorys>
    </Context.Provider>
  );
}
